export default {
  apartmentEmptySelect: {
    defaultMessage: 'No apartment',
    id: 'oneStep.apartment.emptySelect',
  },
  apartmentLabel: {
    defaultMessage: 'Apartment',
    id: 'oneStep.apartment.label',
  },
  deviceApartmentModalCancel: {
    defaultMessage: 'Cancel',
    id: 'deviceApartmentModal.cancel',
  },
  deviceApartmentModalConfirm: {
    defaultMessage: 'Set apartment',
    id: 'deviceApartmentModal.confirm',
  },
  deviceApartmentModalDescription: {
    defaultMessage: 'Apartments group devices and users together for easier administration.',
    id: 'deviceApartmentModal.description',
  },
  deviceApartmentModalHeader: {
    defaultMessage: 'Set apartment to device',
    id: 'deviceApartmentModal.header',
  },
};
